import React from "react";
import "../../assets/styles/banner.css"
import { Link } from "react-router-dom";
import { config } from "../config";
import { useInView } from 'react-intersection-observer';

const Banner = () => {
  const [ref1, inView1] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref2, inView2] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref3, inView3] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref4, inView4] = useInView({ triggerOnce: true, threshold: 0.1 });
  return (
    <div>
      <div className="main-banner">
        <div className="banner-inner">
          <div className="container">
            <div className="row h-100 justify-content-end align-items-end">
              <div className="col-lg-12">
                <div className="hero-content text-center">
                  <h1 className="aos-init aos-animate">High-Purity Standards and Essential Chemicals</h1>
                  <p className="aos-init aos-animate">As a leading global supplier of high-purity chemicals and element standard solutions, we provide premium-quality laboratory reagents and fine chemicals trusted by industries worldwide. Our products undergo sophisticated analysis and rigorous testing to ensure unmatched purity, consistency, and compliance with the highest industry standards. Designed for critical applications in research, pharmaceuticals, and manufacturing, our chemicals and element standard solutions deliver reliable, precise results. With a strong global presence and efficient supply chain, we are committed to supporting our customers with expert guidance and high-performance solutions for diverse and complex scientific needs.</p>
                  <div>
                    <Link
                      to={`${config.appUrl}`}
                      className="btn btn-primary btn-start aos-init aos-animate mr-6" style={{ background: "#eda503 !important" }}
                    >COAs</Link>
                    <Link
                      to={`${config.appUrl}`}
                      className="btn btn-primary btn-start aos-init aos-animate mr-6" style={{ background: "#eda503 !important" }}
                    >CATALOGUE</Link>
                    <Link
                      to={`${config.appUrl}contact-us`}
                      className="btn btn-primary btn-start aos-init main-btn aos-animate" style={{ background: "#eda503 !important" }}
                    >ENQUIRY FOR CATALOGUE</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;